import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
  Row,
  Col,
  Card,
  Typography,
  Select,
  Form,
  Input,
  DatePicker,
  Spin,
  Divider,
  InputNumber,
} from "antd";
import { useNavigate } from "react-router-dom";
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import CustomButton from "../../../components/custom/CustomButton";
import { BOM } from "../../../services/definedMethod";
import definedApi from "../../../services/definedApi";
import cnt from "../../../services/definedConstant";
import appLabel from "../../../config/appLabel";
import dayjs from "dayjs";

import appStatic from "../../../config/appStatic";
import { apiConfig, labelConfig, staticConfig } from "../../../pages/customer/customer.config";
import styles from "../../../assets/styles/styles";

const GLA1200 = (props) => {
  const { userData } = props;
  const { session } = userData;
  const { Text } = Typography;
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const [isLoading, setIsLoading] = useState(false);
  const [officeData, setOfficeData] = useState([]);
  const [currencyData, setCurrencyData] = useState([]);
  const [paymentTypeData, setPaymentTypeData] = useState([]);
  const [clientData, setClientData] = useState([]);
  const [accountData, setAccountData] = useState([]);
  const [glAccountData, setGLAccountData] = useState([]);

  const selectedCurrency = Form.useWatch("currencyCode", form);
  const transactionAmount = Form.useWatch("transactionAmount", form);

  useEffect(() => {
    if (transactionAmount !== undefined) {
      form.setFieldsValue({ glAmount: transactionAmount });
    }
  }, [transactionAmount]);

  useEffect(() => {
    getOfficeList();
    getCurrencyList();
    getPaymentTypes();
  }, []);

  useEffect(() => {
    if (selectedCurrency) {
      getGLAccountList(selectedCurrency);
    } else {
      setGLAccountData([]);
    }
  }, [selectedCurrency]);

  const getOfficeList = () => {
    setIsLoading(true);
    const body = { session };
    BOM.FetchReqAction(body, definedApi.GetOfficesList, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage || err);
      } else {
        const temp = res.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        setOfficeData(temp);
      }
      setIsLoading(false);
    });
  };

  const getCurrencyList = () => {
    setIsLoading(true);
    const body = { session };
    BOM.FetchReqAction(body, definedApi.GetCurrenciesList, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage || err);
      } else {
        const temp =
          res.selectedCurrencyOptions?.map((item) => ({
            value: item.code,
            label: item.displayLabel,
          })) || [];
        setCurrencyData(temp);
      }
      setIsLoading(false);
    });
  };

  const getPaymentTypes = () => {
    setIsLoading(true);
    const body = { session };
    BOM.FetchReqAction(body, definedApi.GetPaymentTypesList, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage || err);
      } else {
        const temp = res.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        setPaymentTypeData(temp);
      }
      setIsLoading(false);
    });
  };

  // 🔹 Fetch and filter GL accounts (only manual entries + currency match)
  const getGLAccountList = (currencyCode) => {
    setIsLoading(true);
    const body = { session };
    BOM.FetchReqAction(body, definedApi.GetSpecificGLList, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors?.[0]?.defaultUserMessage || err);
      } else {
        const filtered =
          res
            ?.filter(
              (item) =>
                item.manualEntriesAllowed === true &&
                (!currencyCode || item.currencyCode === currencyCode),
            )
            .map((item) => ({
              value: item.id,
              label: `${item.glCode} (${item.name})`,
            })) || [];
        setGLAccountData(filtered);
      }
      setIsLoading(false);
    });
  };

  const getClientsByOffice = (officeId) => {
    if (!officeId) return;
    setIsLoading(true);
    const body = { session };
    // const url = `${definedApi.GetClientsByOffice}/${officeId}`;
    const url = `${apiConfig.standingInstructions}/template?fromAccountType=2&toOfficeId=${officeId}`;

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage || err);
      } else {
        const temp =
          res?.toClientOptions?.map((item) => ({
            value: item.id,
            label: `${item.displayName} (${item.id})`,
          })) || [];
        setClientData(temp);
        form.setFieldsValue({ clientId: null, accountId: null });
        setAccountData([]);
      }
      setIsLoading(false);
    });
  };

  const getAccountsByClient = (clientId, officeId) => {
    setIsLoading(true);
    const body = { session };
    const url = `${apiConfig.standingInstructions}/template?fromAccountType=2&toOfficeId=${officeId}&toClientId=${clientId}&toAccountType=2`;

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage || err);
      } else {
        // ✅ Safely map account options (only valid deposit types)

        console.log(res);
        const temp =
          res?.toAccountOptions.map((item) => ({
            value: item.id,
            label: item.accountNo,
          })) || [];

        console.log(temp);

        setAccountData(temp);
        form.setFieldsValue({ accountId: null });
      }
      setIsLoading(false);
    });
  };

  const onCancel = () => {
    navigate("/dashboard");
  };

  const onSubmit = (formValues) => {
    const formattedDate = dayjs(formValues.transactionDate).format("DD MMMM YYYY");

    const payload = {
      officeId: formValues.officeId,
      currencyCode: formValues.currencyCode,
      note: "",
      transactionReference: "",
      transactionDate: formattedDate,
      referenceNumber: formValues.referenceNumber,
      amount: formValues.transactionAmount,
      paymentTypeId: formValues.paymentTypeId,
      locale: "en",
      dateFormat: "dd MMMM yyyy",
      debit: {
        glAccountId: formValues.glAccountId,
        glCode: "",
        glName: "",
        comments: "",
        amount: formValues.transactionAmount,
      },
      method: "POST",
      session,
    };

    console.log("🚀 Final Payload:", payload);

    const url = `${definedApi.NewJournalEntries}/debit-casa-credit-gl?savingsId=${formValues.accountId}`;

    setIsLoading(true);

    BOM.FetchReqAction(
      payload,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(
            cnt.DANGER,
            err?.errors?.[0]?.defaultUserMessage || err.defaultUserMessage || err,
          );
        } else {
          BOM.AlertMsg(cnt.SUCCESS, "Transaction successful!");
          navigate("/dashboard");
        }
        setIsLoading(false);
      },
      // {
      //   navigate,
      //   showCheckerModal: showCheckerApprovalModal,
      //   onCheckerApproval: () => {
      //     navigate("/dashboard");
      //     setIsLoading(false);
      //   },
      // }
    );
  };

  return (
    <MainLayout isEnableRightSidebar={false}>
      <TopContent
        pageTitle={appLabel.addCASAToGlTransfer}
        pageItems={appStatic.addCASAToGlTransfer}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
          headStyle={{ borderBottomWidth: 0 }}
        >
          <Form form={form} layout="vertical" onFinish={onSubmit} style={{ marginTop: "1rem" }}>
            {/* Top section */}
            <Row gutter={[24, 16]}>
              <Col span={12}>
                <Form.Item
                  name="officeId"
                  label={<Text strong>Office*</Text>}
                  rules={[{ required: true, message: "Required field" }]}
                >
                  <Select
                    placeholder="Choose one"
                    options={officeData}
                    showSearch
                    allowClear
                    optionFilterProp="label" // tells Select to filter by the label field
                    filterOption={(input, option) =>
                      (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                    }
                    onChange={(officeId) => getClientsByOffice(officeId)}
                  />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  name="currencyCode"
                  label={<Text strong>Currency*</Text>}
                  rules={[{ required: true, message: "Required field" }]}
                >
                  <Select placeholder="Choose one" options={currencyData} showSearch allowClear />
                </Form.Item>
              </Col>
            </Row>

            {/* Customer Account to Debit */}
            <Divider orientation="left" orientationMargin="0">
              Customer Account to Debit
            </Divider>

            <Row gutter={[24, 16]}>
              <Col span={8}>
                <Form.Item
                  name="clientId"
                  label={<Text strong>Client*</Text>}
                  rules={[{ required: true, message: "Required field" }]}
                >
                  <Select
                    placeholder="Choose one"
                    options={clientData}
                    showSearch
                    allowClear
                    optionFilterProp="label" // tells Select to filter by the label field
                    filterOption={(input, option) =>
                      (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                    }
                    onChange={(clientId) => {
                      const officeId = form.getFieldValue("officeId");
                      getAccountsByClient(clientId, officeId);
                    }}
                  />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name="accountId"
                  label={<Text strong>Account*</Text>}
                  rules={[{ required: true, message: "Required field" }]}
                >
                  <Select placeholder="Choose one" options={accountData} showSearch allowClear />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name="transactionAmount"
                  label={<Text strong>Transaction Amount*</Text>}
                  rules={[{ required: true, message: "Required field" }]}
                >
                  <InputNumber
                    placeholder="Enter amount"
                    style={styles.ofInputFieldNumber}
                    formatter={BOM.FormatAmount}
                    parser={BOM.ParseAmount}
                  />
                </Form.Item>
              </Col>
            </Row>

            {/* GL Account to Credit */}
            <Divider orientation="left" orientationMargin="0">
              GL Account to Credit
            </Divider>

            <Row gutter={[24, 16]}>
              <Col span={12}>
                <Form.Item
                  name="glAccountId"
                  label={<Text strong>GL Account*</Text>}
                  rules={[{ required: true, message: "Required field" }]}
                >
                  <Select
                    placeholder={selectedCurrency ? "Search GL account" : "Select currency first"}
                    options={glAccountData}
                    showSearch
                    allowClear
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                    disabled={!selectedCurrency}
                  />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  name="glAmount"
                  label={<Text strong>GL Amount*</Text>}
                  rules={[{ required: true, message: "Required field" }]}
                >
                  <InputNumber
                    placeholder="Enter amount"
                    style={styles.ofInputFieldNumber}
                    formatter={BOM.FormatAmount}
                    parser={BOM.ParseAmount}
                    disabled
                  />
                </Form.Item>
              </Col>
            </Row>

            {/* Additional Information */}
            <Divider orientation="left" orientationMargin="0">
              Additional Information
            </Divider>

            <Row gutter={[24, 16]}>
              <Col span={8}>
                <Form.Item name="referenceNumber" label={<Text strong>Reference Number</Text>}>
                  <Input placeholder="Enter reference number" />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name="transactionDate"
                  label={<Text strong>Transaction Date*</Text>}
                  rules={[{ required: true, message: "Required field" }]}
                >
                  <DatePicker style={{ width: "100%" }} />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name="paymentTypeId"
                  label={<Text strong>Payment Types*</Text>}
                  rules={[{ required: true, message: "Required field" }]}
                >
                  <Select
                    placeholder="Choose one"
                    options={paymentTypeData}
                    showSearch
                    allowClear
                  />
                </Form.Item>
              </Col>
            </Row>

            {/* Action Buttons */}
            <Row justify="end" style={{ marginTop: "2rem" }} gutter={16}>
              <Col>
                <CustomButton
                  content="Cancel"
                  onClick={onCancel}
                  backgroundColor="#fff"
                  colorText="black"
                  hoverBackground="#F5F5F5"
                  style={{
                    width: "120px",
                    boxShadow: "0px 0px 10px 3px rgba(0,0,0,0.1)",
                  }}
                />
              </Col>

              <Col>
                <CustomButton
                  content="Submit"
                  htmlType="submit"
                  backgroundColor="#92428B"
                  colorText="white"
                  hoverBackground="#AD4EA7"
                  style={{
                    width: "120px",
                    boxShadow: "0px 0px 10px 3px rgba(0,0,0,0.1)",
                  }}
                />
              </Col>
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});

export default connect(mapStateToProps)(GLA1200);
